var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4711 5.80471L8.47114 11.8047C8.34114 11.9347 8.17049 12 7.99982 12C7.82915 12 7.65851 11.9347 7.52851 11.8047L1.52851 5.80471C1.26784 5.54405 1.26784 5.12267 1.52851 4.862C1.78917 4.60134 2.21047 4.60134 2.47113 4.862L7.99982 10.3906L13.5285 4.862C13.7892 4.60134 14.2105 4.60134 14.4711 4.862C14.7318 5.12267 14.7318 5.54405 14.4711 5.80471Z",
    fill: "current",
    stroke: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.521fe96b.svg";
export { ForwardRef as ReactComponent };